import { SVGProps } from "react";

const DownloadIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width={props.width || 24}
    height={props.height || 24}
    fill="none"
    viewBox="-1.7 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Group 289535">
      <path
        id="Vector"
        d="M15.8514 17.3426H1.14865C0.794054 17.3426 0.5 17.0318 0.5 16.6569C0.5 16.282 0.794054 15.9712 1.14865 15.9712H15.8514C16.2059 15.9712 16.5 16.282 16.5 16.6569C16.5 17.0318 16.2059 17.3426 15.8514 17.3426Z"
        fill={props.fill || "#626262"}
      />
      <path
        id="Vector 1 (Stroke)"
        d="M9.10633 1.22841C9.10633 0.893489 8.83483 0.621982 8.4999 0.621982C8.16498 0.621982 7.89348 0.89349 7.89348 1.22841V12.9072L4.76135 9.77509C4.52452 9.53827 4.14055 9.53827 3.90373 9.77509C3.6669 10.0119 3.6669 10.3959 3.90373 10.6327L8.02284 14.7518C8.28631 15.0153 8.71349 15.0153 8.97697 14.7518L13.0961 10.6327C13.3329 10.3959 13.3329 10.0119 13.0961 9.77509C12.8593 9.53827 12.4753 9.53827 12.2385 9.77509L9.10633 12.9072V1.22841Z"
        fill={props.fill || "#626262"}
        stroke={props.fill || "#626262"}
        strokeWidth="0.07"
      />
    </g>
  </svg>
);

export default DownloadIcon;
